const ROUNDS = [
  {
    slug: 'drieZesNegen',
    description:
      'Hier komen de eerste 15 vragen, wie juist antwoordt blijft aan de beurt en elke derde vraag levert 10 seconden op.'
  },
  {
    slug: 'openDeur',
    description:
      'De ronde waarin iedereen 1 vraag krijgt waarbij 4 kernwoorden horen die elk 20 seconden kunnen opleveren.'
  },
  {
    slug: 'puzzel',
    description:
      'Er moeten 3 verbanden worden gezochten tussen de termen die je zo meteen ziet verschijnen, soms moeilijk, maar het goeie nieuws: elk juist antwoord levert 30 seconden op.'
  },
  {
    slug: 'galerij',
    description:
      'In deze ronde zien we een marathon aan foto’s voorbij flitsen en de opdracht is simpel: zeggen wie of wat je ziet. Elk juist antwoord levert 15 seconden op.'
  },
  {
    slug: 'collectiefGeheugen',
    description:
      'In deze ronde krijgt iedereen een filmpje te zien waarbij telkens 150 seconden te verdienen zijn. Na deze ronde kennen we de twee finalisten.'
  },
  {
    slug: 'finale',
    description:
      'Je moet de tijd van andere op nul krijgen en dat doe je door goeie antwoorden te geven want per goed antwoord gaan er 20 seconden af bij de tegenstander. De vraag gaat telkens eerst naar de kandidaat met het minste seconden. Roept ie stop dan gaat de beurt naar de volgende. En we zoeken telkens vijf antwoorden of trefwoorden.'
  }
];

const KEYBOARD_KEYS = [
  'a',
  'z',
  'e',
  'r',
  't',
  'y',
  'u',
  'i',
  'o',
  'p',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  'q',
  'w'
];

export { ROUNDS, KEYBOARD_KEYS };
